import { useRouter } from "next/router";
import { FullWidthTopBar, FullWidthTopBarProps } from "../fullWidthTopBar";

export default function OnlineStoreTopBar({
  barTitle = "Online Store",
  ...props
}: FullWidthTopBarProps) {
  const {
    push,
    query: { medspaSlug },
  } = useRouter();

  const onLogoClick = () => push(`/online-store/${medspaSlug}/packages`);

  return (
    <FullWidthTopBar barTitle={barTitle} onLogoClick={onLogoClick} {...props} />
  );
}
